export const capitalizeFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};